/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import Page from '../Pagination/Pagination'
import HeaderTable from '../../Component/BaseComponent/HeaderTable'
import $ from 'jquery'
import {Checkbox, message} from 'antd'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import cookie from 'react-cookies'
import FromToPicker from '../BaseComponent/FromToPicker'
import {Link} from 'react-router-dom'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import RETAIL from '../BaseComponent/RETAIL'
import SearchableCombo from '../BaseComponent/searchableCombo'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import SearchCustomer from '../BaseComponent/SearchCustomer'
import Sort from '../Pagination/Sort'
import HeaderGrid from '../Pagination/HeaderGrid'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import {divIcon} from 'leaflet'
import {renderToStaticMarkup} from 'react-dom/server'
import {Map, Marker, TileLayer, Popup} from 'react-leaflet'

class EditedAddress extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      editedAddress: [],
      printInfo: [],
      fromDate: '',
      toDate: '',
      modalLocation: false,
      buttonClicked: false,
      confirmModal: false,
      check: false,
      operatorId: '',
      operators: [],
      customerCode: '',
      driverId: '',
      Drivers: [],
      pageNumber: 1,
      pageSize: 10,
      loading: false,
      sortBy: 'editionTime_desc',
      sortData: [
        {
          name: 'ردیف',
          value: 'index',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخ تغییر',
          value: 'editionTime',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'شناسه فاکتور',
          value: 'invoiceId',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تحویل گیرنده',
          value: 'recipientName',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'آدرس',
          value: 'address',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام کاربری',
          value: 'username',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'کد مشتری',
          value: 'customerCode',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'رساننده',
          value: 'editorname',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'کاربر تایید کننده',
          value: 'editorname',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'زمان تایید',
          value: 'confirmTime',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'موقعیت آدرس',
          value: 'address',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تایید',
          value: 'address',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تایید آدرس',
          value: 'address',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      progressing: false
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }

  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_CUSTOMER_EDITEDADDRESS}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          if (!exportStatus) {
            $('.showBaseTable,.print').fadeIn()
            this.setState({
              editedAddress: response.data.object.result,
              countAll: response.data.object.countAll,
              buttonClicked: true,
              toPrintDate: this.state.fromDate == '' ? '-' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
              fromPrintDate: this.state.toDate == '' ? '-' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
              loading: false
            })
          } else {
            this.setState({
              printInfo: response.data.object.result,
              loading: false
            })
          }
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            editedAddress: [],
            loading: false
          })
        }
      })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let driverId = this.state.driverId == null || this.state.driverId == '' ? '' : this.state.driverId.personId
    let operatorId = this.state.operatorId == null || this.state.operatorId == '' ? '' : this.state.operatorId.personId
    let customerCode = this.state.customerCode

    let invoiceId = this.convertDigit(document.getElementById('invoiceId').value.trim())
    let recipientName = document.getElementById('recipientName').value.trim()
    let confirmed = document.getElementById('confirmed').value.trim()
    let customerUsername = document.getElementById('customerUsername').value.trim()

    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }

    if (minDate !== '') {
      filter.editionTimeMin = minDate
    }
    if (maxDate !== '') {
      filter.editionTimeMax = maxDate
    }
    if (driverId !== '') {
      filter.editorId = driverId
    }
    if (operatorId !== '') {
      filter.confirmOperatorId = operatorId
    }
    if (customerCode !== '') {
      filter.customerCode = customerCode.trim()
    }
    if (invoiceId !== '') {
      filter.invoiceId = invoiceId.trim()
    }
    if (recipientName !== '') {
      filter.recipientName = recipientName.trim()
    }
    if (confirmed !== '') {
      filter.confirmed = confirmed
    }
    if (customerUsername !== '') {
      filter.customerUsername = customerUsername.trim()
    }
    return filter
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  componentDidMount() {
    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }

          this.setState({
            Drivers: response.data.object
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    http.get(`${USER_MANAGE.USER_MANAGE_LIST_OPERATOR}`, {}).then((response) => {
      if (response.data.error === null) {
        var operators = response.data.object
        for (let i = 0; i < operators.length; i++) {
          operators[i]['value'] = operators[i].personId
          operators[i]['label'] = operators[i].personId + ' - ' + operators[i].name
        }
        this.setState({
          operators: response.data.object
        })
      }
    })

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
  }

  getValueDriver = (driverId) => {
    this.setState({
      driverId
    })
  }

  filter() {
    if (Object.keys(this.createFilter(false)).length - 4 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport(false)
        }
      )
    }
  }

  showLocation = (latitude, longitude, recipientName, id, confirmed) => {
    this.setState({
      latitude,
      longitude,
      recipientName,
      modalLocation: !this.state.modalLocation,
      id,
      confirmedAddress: confirmed
    })
  }

  togglePosition = () => {
    this.setState({
      latitude: '',
      lonitude: '',
      recipientName: '',
      modalLocation: !this.state.modalLocation
    })
  }
  cancelPosition = () => {
    this.togglePosition()
  }

  confirm = (id, recipientName) => {
    this.setState({
      id,
      recipientName,
      confirmModal: !this.state.confirmModal,
      modalLocation: false
    })
  }

  toggleConfirm = () => {
    this.setState({
      id: '',
      recipientName: '',
      confirmModal: !this.state.confirmModal,
      check: false
    })
  }
  cancelConfirm = () => {
    this.toggleConfirm()
  }

  confirmOk = () => {
    let {id} = this.state
    let data = {
      id
    }
    this.setState({
      progressing: true
    })
    http
      .post(`${RETAIL.RETAIL_COMPANY_EDITEDADDRESSES_CONFIRM}`, data, {})
      .then((response) => {
        this.setState({
          progressing: false
        })
        if (response.data.error === null) {
          message.success('آدرس با موفقیت ثبت شد')
          this.getReport(false)
          this.toggleConfirm()
        }
      })
      .catch(() => {
        this.setState({
          progressing: false
        })
      })
  }

  exportExcel = () => {
    http
      .get(
        `${
          REPORT_RETAIL.REPORT_RETAIL_CUSTOMER_EDITEDADDRESS
        }?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['editionTime'] = jMoment(excelReport[i]['editionTime']).format('jYY/jMM/jDD HH:mm')

            if (excelReport[i]['confirmTime'] === null) {
              excelReport[i]['confirmTime'] = ''
            } else {
              excelReport[i]['confirmTime'] = jMoment(excelReport[i]['confirmTime']).format('jYY/jMM/jDD HH:mm')
            }

            if (excelReport[i]['confirmed']) {
              excelReport[i]['confirmed'] = 'تایید شده'
            } else {
              excelReport[i]['confirmed'] = 'تایید نشده'
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })
  }

  getPrintInfo = () => {
    this.setState({
      loading: true
    })
    this.getReport(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  changeFieldConfirm(e) {
    const target = e.target
    const value = target.type == 'checkbox' ? target.checked : target.value
    const name = target.name
    this.setState({
      [name]: value
    })
  }

  getValueOperator = (operatorId) => {
    this.setState({
      operatorId
    })
  }

  getSingleCustomerCode = (customerCode) => {
    this.setState({
      customerCode
    })
  }

  render() {
    const modalStyle = {
      maxWidth: '96%',
      height: '300px'
    }

    const unSelected = renderToStaticMarkup(<img src={require('../../image/requestPack.png')} />)

    let name = cookie.load('name')

    let {pageNumber, pageSize, loading} = this.state

    let printColumns = [
      'ردیف',
      'تاریخ تغییر',
      'شناسه فاکتور',
      'تحویل گیرنده',
      'آدرس',
      'نام کاربری',
      'کد مشتری',
      'رساننده',
      'تایید کننده',
      'تایید',
      'زمان تایید'
    ]

    return (
      <div className="rtl">
        <Loader show={loading} />

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش آدرس های ویرایش شده.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'editionTime'}
                field={'editionTime'}
                title={'تاریخ تغییر'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'invoiceId'}
                field={'invoiceId'}
                title={'شناسه فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'recipientName'}
                field={'recipientName'}
                title={'تحویل گیرنده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'address'}
                field={'address'}
                title={'آدرس'}
                width="600px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'customerusername'}
                field={'customer.username'}
                title={'نام کاربری'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'userCode'}
                field={'customer.userCode'}
                title={'کد مشتری'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'editot'}
                field={'editor.name'}
                title={'رساننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              {/*<gridColumn key={'operator'} field={'operator.name'} title={'تایید کننده'} width="100px"*/}
              {/*            footerCellOptions={{wrap: true, textAlign: 'center'}}/>*/}

              <gridColumn
                key={'confirmed'}
                field={'confirmed'}
                title={'وضعیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'confirmTime'}
                field={'confirmTime'}
                title={'زمان تایید'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش آدرس های تغییر یافته "
              headerColSpan={11}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={5}
              rightColSpan={5}
              centerColSpan={1}
              centerSection={''}
              rightSection={'تاریخ تغییر از : ' + this.state.toPrintDate + ' تا ' + this.state.fromPrintDate}
              columns={printColumns}
            />
            <tbody>
              {this.state.printInfo.map((edited, index) => (
                <tr key={'i' + index} style={index % 2 == 0 ? {backgroundColor: '#f1f1f1'} : {backgroundColor: '#fff'}}>
                  <td>{index + 1}</td>
                  <td>{jMoment(edited.editionTime).format('jYYYY/jM/jD')}</td>
                  <td>{edited.invoiceId}</td>
                  <td>{edited.recipientName}</td>
                  <td>{edited.address}</td>
                  <td>{edited.customer.username}</td>
                  <td>{edited.customer.userCode}</td>
                  <td>{edited.editor === null ? '-' : edited.editor.name}</td>
                  <td>{edited.operator === null ? '-' : edited.operator.name}</td>
                  <td className="confirmIgnor">{edited.confirmed ? 'تایید شده' : 'تایید نشده'}</td>
                  <td>{edited.confirmTime === null ? '-' : jMoment(edited.confirmTime).format('jYY/jMM/jDD HH:mm')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>عمومی</li>
            <li>آدرس های ویرایش شده</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>

                {/*<ReactToPrint*/}
                {/*copyStyles={false}*/}
                {/*pageStyle={A4StyleLandScape}*/}
                {/*trigger={() => <button className='printButton'>*/}
                {/*چاپ لیست*/}
                {/*</button>*/}
                {/*}*/}

                {/*content={() => this.printPart}*/}
                {/*/>*/}
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <SearchCustomer
                  label={'کد مشتری'}
                  getSingleCustomerCode={this.getSingleCustomerCode}
                  singleResult={true}
                  searchLabel={'جست و جوی مشتری'}
                />

                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ تغییر از"
                  toLabel="تاریخ تغییر تا"
                  defaulValue={true}
                  fromId="from"
                  toId="to"
                />

                <div className="formComponent">
                  <label>شناسه فاکتور:</label>
                  <input type="text" className="form-control" id="invoiceId" name="invoiceId" />
                </div>

                <div className="formComponent">
                  <label>نام تحویل گیرنده :</label>
                  <input type="text" className="form-control" id="recipientName" name="recipientName" />
                </div>

                <div className="formComponent">
                  <label>نام کاربری مشتری :</label>
                  <input type="text" className="form-control" id="customerUsername" name="customerUsername" />
                </div>

                <div className="formComponent">
                  <label>وضعیت تایید :</label>
                  <select className="form-control" id="confirmed">
                    <option value="">------</option>
                    <option value={1}>تایید شده</option>
                    <option value={0}>تایید نشده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.Drivers}
                    getValueCombo={this.getValueDriver}
                    lableText="رساننده"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    isDisabled={false}
                  />
                </div>

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.operators}
                    getValueCombo={this.getValueOperator}
                    lableText="کاربر تایید کننده"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    className="font-weight-bold"
                  />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />

                  {this.state.editedAddress.map((edited, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{jMoment(edited.editionTime).format('jYYYY/jMM/jDD HH:mm')}</td>
                      <td>{edited.invoiceId}</td>
                      <td>{edited.recipientName}</td>
                      <td>{edited.address}</td>
                      <td>{edited.customer.username}</td>
                      <td>{edited.customer.userCode}</td>
                      <td>{edited.editor === null ? '-' : edited.editor.name}</td>
                      <td>{edited.operator === null ? '-' : edited.operator.name}</td>
                      <td>
                        {edited.confirmTime === null ? '-' : jMoment(edited.confirmTime).format('jYY/jMM/jDD HH:mm')}
                      </td>
                      <td>
                        <button
                          onClick={() =>
                            this.showLocation(
                              edited.latitude,
                              edited.longitude,
                              edited.recipientName,
                              edited.editedAddressId,
                              edited.confirmed
                            )
                          }
                        >
                          <img src={require('../../image/loc.svg')} alt={'loc'} />
                        </button>
                      </td>

                      <td className="confirmIgnor">
                        {edited.confirmed ? (
                          <img src={require('../../image/confirm.svg')} alt={'confirm'} title={'تایید شده'} />
                        ) : (
                          <img src={require('../../image/ignor.svg')} alt={'ignor'} title="تایید نشده" />
                        )}
                      </td>

                      <td>
                        {!edited.confirmed ? (
                          <button onClick={() => this.confirm(edited.editedAddressId, edited.recipientName)}>
                            <img src={require('../../image/editDriver.svg')} alt={'loc'} />
                          </button>
                        ) : null}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
              </div>
            </div>
          </div>
        </div>

        <Modal isOpen={this.state.modalLocation} toggle={this.togglePosition} size="lg">
          <ModalHeader toggle={this.togglePosition}>
            <p>آدرس مشتری : {this.state.recipientName}</p>
          </ModalHeader>
          <ModalBody>
            <div className="addressMap">
              <Map center={[this.state.latitude, this.state.longitude]} zoom={10} style={{height: '500px'}}>
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <Marker
                  icon={divIcon({
                    html: unSelected,
                    iconSize: [30, 30],
                    iconAnchor: [10, 38]
                  })}
                  position={[this.state.latitude, this.state.longitude]}
                  title={this.state.recipientName}
                />
              </Map>
              {/* <Map
                google={this.props.google}
                zoom={13}
                style={modalStyle}
                initialCenter={{
                  lat: this.state.latitude,
                  lng: this.state.longitude,
                }}
              >
                <Marker
                  icon={require("../../image/requestPack.png")}
                  title={this.state.recipientName}
                  position={{
                    lat: this.state.latitude,
                    lng: this.state.longitude,
                  }}
                />
              </Map> */}
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={this.cancelPosition}>
              بستن
            </button>
            {!this.state.confirmedAddress ? (
              <button className="confirmBtnModal" onClick={() => this.confirm(this.state.id, this.state.recipientName)}>
                تایید آدرس
              </button>
            ) : null}
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.confirmModal} toggle={this.toggleConfirm} size="sm">
          <ModalHeader toggle={this.toggleConfirm}>
            <p>تایید آدرس مشتری : {this.state.recipientName}</p>
          </ModalHeader>
          <ModalBody>
            <p className="titleSm">
              <Checkbox name="check" tabIndex="4" onChange={this.changeFieldConfirm.bind(this)}>
                آیا از انجام عملیات مطمئن هستید؟
              </Checkbox>
            </p>
          </ModalBody>
          <ModalFooter>
            <button
              className="confirmBtnModal"
              disabled={!this.state.check || this.state.progressing ? true : false}
              onClick={this.confirmOk}
            >
              تایید
            </button>
            <button className="cancelBtnModal" onClick={this.cancelConfirm}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default EditedAddress
